import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container } from '../../../src/components/Grid';
import { Section } from '../../../src/components/Layout';
import List from '../List/index';
import Text from '../../../src/components/Typography/Text';
import theme from '../../../src/theme';

class Category extends PureComponent {
  renderList = item => {
    const { filters } = this.props;
    const { id, label, items, categorySlug } = item;

    const displayCategory = filters[id];

    return (
      displayCategory && (
        <List
          key={id}
          id={id}
          label={label}
          items={items}
          categorySlug={categorySlug}
          filters={this.props.filters}
        />
      )
    );
  };

  renderLists = () => {
    return this.props.items.map(this.renderList);
  };

  render() {
    const { label } = this.props;

    return (
      <Section className="category">
        <Container>
          <Text variant="heading2" color={theme.color.brand.primary} as="h2">
            {label}
          </Text>
          {this.renderLists()}
        </Container>
      </Section>
    );
  }
}

Category.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired
};

export default Category;
